/**
 * Model labs whose display names start with 0-9 and A-C, in catalog order.
 *
 * Generated by `pnpm logos:sync`; see `../model-labs.ts`.
 */
export const LABS_0_C = [
    {
        id: 'zeroone',
        name: '01.AI',
        light: 'zeroone/zeroone-light.svg',
        dark: 'zeroone/zeroone-dark.svg',
    },
    { id: 'yi', name: '01.AI (Yi)', light: 'yi/yi-light.svg', dark: 'yi/yi-dark.svg' },
    { id: 'ai302', name: '302.AI', light: 'ai302/ai302-light.svg', dark: 'ai302/ai302-dark.svg' },
    { id: 'ai360', name: '360', light: 'ai360/ai360-light.svg', dark: 'ai360/ai360-dark.svg' },
    { id: 'ace', name: 'Ace', light: 'ace/ace-light.svg', dark: 'ace/ace-dark.svg' },
    { id: 'adobe', name: 'Adobe', light: 'adobe/adobe-light.svg', dark: 'adobe/adobe-dark.svg' },
    {
        id: 'adobefirefly',
        name: 'Adobe Firefly',
        light: 'adobefirefly/adobefirefly-light.svg',
        dark: 'adobefirefly/adobefirefly-dark.svg',
    },
    { id: 'agui', name: 'AG-UI', light: 'agui/agui-light.svg', dark: 'agui/agui-dark.svg' },
    {
        id: 'agentvoice',
        name: 'Agent Voice',
        light: 'agentvoice/agentvoice-light.svg',
        dark: 'agentvoice/agentvoice-dark.svg',
    },
    {
        id: 'agnesai',
        name: 'Agnes AI',
        light: 'agnesai/agnesai-light.svg',
        dark: 'agnesai/agnesai-dark.svg',
    },
    {
        id: 'aistudio',
        name: 'AI Studio',
        light: 'aistudio/aistudio-light.svg',
        dark: 'aistudio/aistudio-dark.svg',
    },
    { id: 'ai21', name: 'AI21 Labs', light: 'ai21/ai21-light.svg', dark: 'ai21/ai21-dark.svg' },
    {
        id: 'aihubmix',
        name: 'AiHubMix',
        light: 'aihubmix/aihubmix-light.svg',
        dark: 'aihubmix/aihubmix-dark.svg',
    },
    {
        id: 'aimass',
        name: 'AiMass',
        light: 'aimass/aimass-light.svg',
        dark: 'aimass/aimass-dark.svg',
    },
    {
        id: 'aionlabs',
        name: 'AionLabs',
        light: 'aionlabs/aionlabs-light.svg',
        dark: 'aionlabs/aionlabs-dark.svg',
    },
    {
        id: 'airjelly',
        name: 'AirJelly',
        light: 'airjelly/airjelly-light.svg',
        dark: 'airjelly/airjelly-dark.svg',
    },
    {
        id: 'akashchat',
        name: 'Akash Chat',
        light: 'akashchat/akashchat-light.svg',
        dark: 'akashchat/akashchat-dark.svg',
    },
    {
        id: 'alephalpha',
        name: 'Aleph Alpha',
        light: 'alephalpha/alephalpha-light.svg',
        dark: 'alephalpha/alephalpha-dark.svg',
    },
    {
        id: 'alibaba',
        name: 'Alibaba',
        light: 'alibaba/alibaba-light.svg',
        dark: 'alibaba/alibaba-dark.svg',
    },
    {
        id: 'alibabacloud',
        name: 'Alibaba Cloud',
        light: 'alibabacloud/alibabacloud-light.svg',
        dark: 'alibabacloud/alibabacloud-dark.svg',
    },
    {
        id: 'ai2',
        name: 'Allen Institute for AI',
        light: 'ai2/ai2-light.svg',
        dark: 'ai2/ai2-dark.svg',
    },
    {
        id: 'bedrock',
        name: 'Amazon Bedrock',
        light: 'bedrock/bedrock-light.svg',
        dark: 'bedrock/bedrock-dark.svg',
    },
    { id: 'nova', name: 'Amazon Nova', light: 'nova/nova-light.svg', dark: 'nova/nova-dark.svg' },
    { id: 'amp', name: 'Amp', light: 'amp/amp-light.svg', dark: 'amp/amp-dark.svg' },
    {
        id: 'anspire',
        name: 'Anspire',
        light: 'anspire/anspire-light.svg',
        dark: 'anspire/anspire-dark.svg',
    },
    {
        id: 'antgroup',
        name: 'Ant Group',
        light: 'antgroup/antgroup-light.svg',
        dark: 'antgroup/antgroup-dark.svg',
    },
    {
        id: 'anthropic',
        name: 'Anthropic',
        light: 'anthropic/anthropic-light.svg',
        dark: 'anthropic/anthropic-dark.svg',
    },
    {
        id: 'antigravity',
        name: 'Antigravity',
        light: 'antigravity/antigravity-light.svg',
        dark: 'antigravity/antigravity-dark.svg',
    },
    {
        id: 'anyscale',
        name: 'Anyscale',
        light: 'anyscale/anyscale-light.svg',
        dark: 'anyscale/anyscale-dark.svg',
    },
    {
        id: 'apertis',
        name: 'Apertis',
        light: 'apertis/apertis-light.svg',
        dark: 'apertis/apertis-dark.svg',
    },
    { id: 'apple', name: 'Apple', light: 'apple/apple-light.svg', dark: 'apple/apple-dark.svg' },
    { id: 'arcee', name: 'Arcee AI', light: 'arcee/arcee-light.svg', dark: 'arcee/arcee-dark.svg' },
    {
        id: 'askverdict',
        name: 'AskVerdict',
        light: 'askverdict/askverdict-light.svg',
        dark: 'askverdict/askverdict-dark.svg',
    },
    {
        id: 'assemblyai',
        name: 'AssemblyAI',
        light: 'assemblyai/assemblyai-light.svg',
        dark: 'assemblyai/assemblyai-dark.svg',
    },
    {
        id: 'atlascloud',
        name: 'Atlas Cloud',
        light: 'atlascloud/atlascloud-light.svg',
        dark: 'atlascloud/atlascloud-dark.svg',
    },
    {
        id: 'automatic',
        name: 'AUTOMATIC1111',
        light: 'automatic/automatic-light.svg',
        dark: 'automatic/automatic-dark.svg',
    },
    { id: 'aws', name: 'AWS', light: 'aws/aws-light.svg', dark: 'aws/aws-dark.svg' },
    { id: 'aya', name: 'Aya', light: 'aya/aya-light.svg', dark: 'aya/aya-dark.svg' },
    { id: 'azure', name: 'Azure', light: 'azure/azure-light.svg', dark: 'azure/azure-dark.svg' },
    {
        id: 'azureai',
        name: 'Azure AI',
        light: 'azureai/azureai-light.svg',
        dark: 'azureai/azureai-dark.svg',
    },
    { id: 'baai', name: 'BAAI', light: 'baai/baai-light.svg', dark: 'baai/baai-dark.svg' },
    {
        id: 'baichuan',
        name: 'Baichuan',
        light: 'baichuan/baichuan-light.svg',
        dark: 'baichuan/baichuan-dark.svg',
    },
    { id: 'baidu', name: 'Baidu', light: 'baidu/baidu-light.svg', dark: 'baidu/baidu-dark.svg' },
    {
        id: 'baiducloud',
        name: 'Baidu Cloud',
        light: 'baiducloud/baiducloud-light.svg',
        dark: 'baiducloud/baiducloud-dark.svg',
    },
    {
        id: 'bailian',
        name: 'Bailian',
        light: 'bailian/bailian-light.svg',
        dark: 'bailian/bailian-dark.svg',
    },
    {
        id: 'baseten',
        name: 'Baseten',
        light: 'baseten/baseten-light.svg',
        dark: 'baseten/baseten-dark.svg',
    },
    {
        id: 'bilibili',
        name: 'Bilibili',
        light: 'bilibili/bilibili-light.svg',
        dark: 'bilibili/bilibili-dark.svg',
    },
    {
        id: 'bilibiliindex',
        name: 'Bilibili Index',
        light: 'bilibiliindex/bilibiliindex-light.svg',
        dark: 'bilibiliindex/bilibiliindex-dark.svg',
    },
    { id: 'bing', name: 'Bing', light: 'bing/bing-light.svg', dark: 'bing/bing-dark.svg' },
    { id: 'bfl', name: 'Black Forest Labs', light: 'bfl/bfl-light.svg', dark: 'bfl/bfl-dark.svg' },
    { id: 'bocha', name: 'Bocha', light: 'bocha/bocha-light.svg', dark: 'bocha/bocha-dark.svg' },
    { id: 'brave', name: 'Brave', light: 'brave/brave-light.svg', dark: 'brave/brave-dark.svg' },
    {
        id: 'briaai',
        name: 'Bria AI',
        light: 'briaai/briaai-light.svg',
        dark: 'briaai/briaai-dark.svg',
    },
    {
        id: 'browserless',
        name: 'Browserless',
        light: 'browserless/browserless-light.svg',
        dark: 'browserless/browserless-dark.svg',
    },
    {
        id: 'burncloud',
        name: 'BurnCloud',
        light: 'burncloud/burncloud-light.svg',
        dark: 'burncloud/burncloud-dark.svg',
    },
    {
        id: 'bytedance',
        name: 'ByteDance',
        light: 'bytedance/bytedance-light.svg',
        dark: 'bytedance/bytedance-dark.svg',
    },
    {
        id: 'capcut',
        name: 'CapCut',
        light: 'capcut/capcut-light.svg',
        dark: 'capcut/capcut-dark.svg',
    },
    {
        id: 'celestoai',
        name: 'Celesto AI',
        light: 'celestoai/celestoai-light.svg',
        dark: 'celestoai/celestoai-dark.svg',
    },
    {
        id: 'centml',
        name: 'CentML',
        light: 'centml/centml-light.svg',
        dark: 'centml/centml-dark.svg',
    },
    {
        id: 'cerebras',
        name: 'Cerebras',
        light: 'cerebras/cerebras-light.svg',
        dark: 'cerebras/cerebras-dark.svg',
    },
    {
        id: 'chatglm',
        name: 'ChatGLM',
        light: 'chatglm/chatglm-light.svg',
        dark: 'chatglm/chatglm-dark.svg',
    },
    {
        id: 'cherrystudio',
        name: 'Cherry Studio',
        light: 'cherrystudio/cherrystudio-light.svg',
        dark: 'cherrystudio/cherrystudio-dark.svg',
    },
    {
        id: 'civitai',
        name: 'Civitai',
        light: 'civitai/civitai-light.svg',
        dark: 'civitai/civitai-dark.svg',
    },
    {
        id: 'claude',
        name: 'Claude',
        light: 'claude/claude-light.svg',
        dark: 'claude/claude-dark.svg',
    },
    {
        id: 'claudecode',
        name: 'Claude Code',
        light: 'claudecode/claudecode-light.svg',
        dark: 'claudecode/claudecode-dark.svg',
    },
    { id: 'cline', name: 'Cline', light: 'cline/cline-light.svg', dark: 'cline/cline-dark.svg' },
    {
        id: 'clipdrop',
        name: 'Clipdrop',
        light: 'clipdrop/clipdrop-light.svg',
        dark: 'clipdrop/clipdrop-dark.svg',
    },
    {
        id: 'cloudflare',
        name: 'Cloudflare',
        light: 'cloudflare/cloudflare-light.svg',
        dark: 'cloudflare/cloudflare-dark.svg',
    },
    {
        id: 'codebuddy',
        name: 'CodeBuddy',
        light: 'codebuddy/codebuddy-light.svg',
        dark: 'codebuddy/codebuddy-dark.svg',
    },
    {
        id: 'codeflicker',
        name: 'CodeFlicker',
        light: 'codeflicker/codeflicker-light.svg',
        dark: 'codeflicker/codeflicker-dark.svg',
    },
    {
        id: 'codegeex',
        name: 'CodeGeeX',
        light: 'codegeex/codegeex-light.svg',
        dark: 'codegeex/codegeex-dark.svg',
    },
    { id: 'codex', name: 'Codex', light: 'codex/codex-light.svg', dark: 'codex/codex-dark.svg' },
    {
        id: 'cogvideo',
        name: 'Cogvideo',
        light: 'cogvideo/cogvideo.svg',
        dark: 'cogvideo/cogvideo.svg',
    },
    { id: 'cogview', name: 'Cogview', light: 'cogview/cogview.svg', dark: 'cogview/cogview.svg' },
    {
        id: 'cohere',
        name: 'Cohere',
        light: 'cohere/cohere-light.svg',
        dark: 'cohere/cohere-dark.svg',
    },
    {
        id: 'cometapi',
        name: 'CometAPI',
        light: 'cometapi/cometapi-light.svg',
        dark: 'cometapi/cometapi-dark.svg',
    },
    {
        id: 'comfyui',
        name: 'ComfyUI',
        light: 'comfyui/comfyui-light.svg',
        dark: 'comfyui/comfyui-dark.svg',
    },
    {
        id: 'commanda',
        name: 'CommandA',
        light: 'commanda/commanda-light.svg',
        dark: 'commanda/commanda-dark.svg',
    },
    {
        id: 'copilot',
        name: 'Copilot',
        light: 'copilot/copilot-light.svg',
        dark: 'copilot/copilot-dark.svg',
    },
    {
        id: 'copilotkit',
        name: 'CopilotKit',
        light: 'copilotkit/copilotkit-light.svg',
        dark: 'copilotkit/copilotkit-dark.svg',
    },
    { id: 'coqui', name: 'Coqui', light: 'coqui/coqui-light.svg', dark: 'coqui/coqui-dark.svg' },
    { id: 'coze', name: 'Coze', light: 'coze/coze-light.svg', dark: 'coze/coze-dark.svg' },
    {
        id: 'crewai',
        name: 'CrewAI',
        light: 'crewai/crewai-light.svg',
        dark: 'crewai/crewai-dark.svg',
    },
    {
        id: 'crusoe',
        name: 'Crusoe',
        light: 'crusoe/crusoe-light.svg',
        dark: 'crusoe/crusoe-dark.svg',
    },
    {
        id: 'cursor',
        name: 'Cursor',
        light: 'cursor/cursor-light.svg',
        dark: 'cursor/cursor-dark.svg',
    },
    {
        id: 'cybercut',
        name: 'CyberCut',
        light: 'cybercut/cybercut-light.svg',
        dark: 'cybercut/cybercut-dark.svg',
    },
];
//# sourceMappingURL=labs-0-c.js.map